/* CREALIS — hoja de "agregar rápido" (bottom sheet en celular, popover en
   escritorio). Custom element porque puede insertarse en contextos donde
   un <script> inline no se ejecutaría (ver crealis-cart-oferta.js para el
   mismo gotcha) — aquí es más por consistencia y robustez que necesidad
   estricta, ya que estas secciones cargan en la carga normal de página. */
class CrQuickAdd extends HTMLElement {
  connectedCallback() {
    if (this.dataset.listo) return;
    this.dataset.listo = '1';

    const trigger = this.querySelector('[data-cr-qa-trigger]');
    const dialog = this.querySelector('dialog');
    const closeBtn = this.querySelector('[data-cr-qa-close]');
    if (!trigger || !dialog) return;

    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      dialog.showModal();
    });

    closeBtn?.addEventListener('click', () => dialog.close());

    dialog.addEventListener('click', (e) => {
      if (e.target === dialog) dialog.close();
    });

    dialog.addEventListener('cart:update', () => dialog.close());
  }
}

if (!customElements.get('cr-quick-add')) {
  customElements.define('cr-quick-add', CrQuickAdd);
}
